export enum UnitType {
    TIME = 'Time',
    STRING = 'String'
}